import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';

@Component({
  selector: 'app-order-payment-skeleton',
  templateUrl: './order-payment-skeleton.component.html',
  styleUrls: ['./order-payment-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  host: { class: 'order-payment-skeleton' }
})
export class OrderPaymentSkeletonComponent {
  @Input() isModalView = false;
  @Input() isMobileModalView = false;
  @Input() paymentMethodsOnly = false;
}
